
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { FeedDto } from './FeedDto';

@Injectable()
export class FeedService {

  constructor(private http: HttpClient) { }

   getNews(count?: number): Promise<FeedDto[]> {
    return this.http.get(environment.apiUrl + `api/feed/news/${count}`).map(response => <any>response).toPromise(); 
  }
  

  private handleError(error: any) {
    console.error('ApiService::handleError', error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/typewriter/output/FeedController.ts